import React, { useState, useEffect } from "react";
import { Drawer, IconButton, List } from "@material-ui/core";
import {
  ArrowBack as ArrowBackIcon,
  Group as GroupIcon,
  Home as HomeIcon,
  Layers as LayersIcon,
  Language as LanguageIcon,
  Notifications as NotificationsIcon,
  ArrowForward as ArrowForwardIcon,
  Receipt,AttachMoney,Portrait,Block,Timeline
} from "@material-ui/icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAd } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from "@material-ui/styles";
import { withRouter } from "react-router-dom";
import classNames from "classnames";

// styles
import useStyles from "./styles";

// components
import SidebarLink from "./components/SidebarLink/SidebarLink";

// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
} from "../../context/LayoutContext";

let structure = [];
const role = localStorage.getItem('role');
if(role === "ADMIN"){
  structure = [
    { id: 0, label: "Dashboard", link: "/dashboard", icon: <HomeIcon /> }    
  ];
  if(localStorage.getItem('publisher-BrowserNotification') === "true"){
    structure.push({ id: 1, label: "Push Notifications", link: "/pushNotifications", icon: <NotificationsIcon /> });
  }
  structure.push(
    { id: 2, label: "Report by Publisher", link: "/reportByPublisher", icon: <Receipt /> },
    { id: 3, label: "Sites", link: "/sites", icon: <LanguageIcon /> },
    { id: 4, label: "Users", link: "/users", icon: <GroupIcon /> },
    { id: 5, label: "Layout Types", link: "/layoutTypes", icon: <LayersIcon /> },
    { id: 6, label: "Layout Definition", link: "/layoutDefinition", icon: <LayersIcon /> },
    { id: 7, label: "Ad Units", link: "/adunits", icon: <FontAwesomeIcon icon={faAd} className="fa-2x"/> },
    { id: 8, label: "Placements by Publisher", link: "/placementsByPublisher", icon: <LayersIcon /> },
    { id: 9, label: "Report Payments", link: "/reportPayments", icon: <AttachMoney /> },
    { id: 10, label: "Received Payments", link: "/receivedPayments", icon: <AttachMoney /> },
    { id: 11, label: "Networks", link: "/networks", icon: <Portrait /> },
    { id: 12, label: "Black List", link: "/blackList", icon: <Block /> },
    { id: 13, label: "Indicators by Publisher", link: "/indicatorsByPublisher", icon: <ArrowForwardIcon /> },
    { id: 14, label: "Integrations", link: "/analyticsIntegration", icon: <Timeline /> },

    );
} else if(role === "CLIENT") {
  structure = [
    { id: 0, label: "Dashboard", link: "/dashboard", icon: <HomeIcon /> },
    { id: 1, label: "Received Payments", link: "/receivedPayments", icon: <AttachMoney /> },
    // { id: 2, label: "Analytics Integration", link: "/analyticsIntegration", icon: <Timeline /> },
    (localStorage.getItem('publisher-BrowserNotification') === "true" ? { id: 3, label: "Push Notifications", link: "/pushNotifications", icon: <NotificationsIcon /> } : { id: 3 })
  ];
} else if(role === "SALES") {
  structure = [
    { id: 0, label: "Dashboard", link: "/dashboard", icon: <HomeIcon /> },
    { id: 1, label: "Report by Publisher", link: "/reportByPublisher", icon: <Receipt /> }
  ];
}

function Sidebar({ location }) {
  var classes = useStyles();
  var theme = useTheme();

  // global
  var { isSidebarOpened } = useLayoutState();
  var layoutDispatch = useLayoutDispatch();

  // local
  var [isPermanent, setPermanent] = useState(true);

  useEffect(function() {
    window.addEventListener("resize", handleWindowWidthChange);
    handleWindowWidthChange();
    return function cleanup() {
      window.removeEventListener("resize", handleWindowWidthChange);
    };
  });

  return (
    <Drawer
      variant={isPermanent ? "permanent" : "temporary"}
      className={classNames(classes.drawer, {
        [classes.drawerOpen]: isSidebarOpened,
        [classes.drawerClose]: !isSidebarOpened,
      })}
      classes={{
        paper: classNames({
          [classes.drawerOpen]: isSidebarOpened,
          [classes.drawerClose]: !isSidebarOpened,
        }),
      }}
      open={isSidebarOpened}
    >
      <div className={classes.toolbar} />
      <div className={classes.mobileBackButton}>
        <IconButton onClick={() => toggleSidebar(layoutDispatch)}>
          <ArrowBackIcon
            classes={{
              root: classNames(classes.headerIcon, classes.headerIconCollapse),
            }}
          />
        </IconButton>
      </div>
      <List className={classes.sidebarList}>
        {structure.map(link => (
          <SidebarLink
            key={link.id}
            location={location}
            isSidebarOpened={isSidebarOpened}
            {...link}
          />
        ))}
      </List>
    </Drawer>
  );

  // ##################################################################
  function handleWindowWidthChange() {
    var windowWidth = window.innerWidth;
    var breakpointWidth = theme.breakpoints.values.md;
    var isSmallScreen = windowWidth < breakpointWidth;

    if (isSmallScreen && isPermanent) {
      setPermanent(false);
    } else if (!isSmallScreen && !isPermanent) {
      setPermanent(true);
    }
  }
}

export default withRouter(Sidebar);
